import { store } from "src/store/store";
import { getDateOnly } from "src/utils/getDateOnly";
import { setRemainingVideoUsage, setCheckDate } from "./actions";

export function getRemainingVideoUsage(state) {
  const { lastCheckDate, availableVideoUsage } = state.firebase;
  const today = getDateOnly();

  if (today > new Date(lastCheckDate)) {
    store.dispatch(setRemainingVideoUsage(availableVideoUsage));
    store.dispatch(setCheckDate());
  }

  return store.getState().firebase.remainingVideoUsage;
}
